import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import { faFaceSadTear } from "@fortawesome/free-regular-svg-icons";

import NavBar from "../components/common/navBar";
import Logo from "../components/common/logo";

import INFO from "../data/user";

import "./styles/404.css";

const Notfound = () => {
	useEffect(() => {
		document.title = `404 | ${INFO.main.title}`;
	}, []);

	return (
		<React.Fragment>
			<div className="not-found page-content">
				<NavBar />
				<div className="content-wrapper">
					<div className="notfound-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="notfound-container">
						<main className="notfound-message">
							<h1 className="notfound-title">
								Page not found <FontAwesomeIcon icon={faFaceSadTear} aria-hidden="true" />
							</h1>
							<p className="not-found-message">
								This page may have moved or the link may be incorrect.
							</p>
							<Link to="/" className="not-found-link">
								Go back to the home page
							</Link>
						</main>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Notfound;
